import React from 'react';
import {
    BrowserRouter,
    Navigate,
    Routes,
    Route,
} from 'react-router-dom';

import UploadView from '../../views/UploadView';
import LinkingView from '../../views/LinkingView';
import ExportView from '../../views/ExportView';
import AssetTrackingView from '../../views/AssetTrackingView';
import EdlView from '../../views/EdlView';
import IllusionView from '../../views/IllusionView';
import SettingsView from '../../views/SettingsView';
import ExploreView from '../../views/ExploreView';
import ProductionView from '../../views/ProductionView';
import AboutView from '../../views/AboutView';
import FDLView from '../../views/FdlView';
import DeliverableConfigView from '../../views/DeliverableConfigView';
import SourceConfigView from '../../views/SourceConfigView';
import KonsolConfigView from '../../views/KonsolConfigView'
import LUTView from '../../views/LUTView';

import TranskoderView from '../../views/TranskoderView';

import AccessManageView from '../../views/AccessManageView';
import AccountManageView from '../../views/AccountManageView';
import PipelineLab from '../../views/PipelineLabView';


var routes = [
    {
        key: 'default',
        path: '/',
        view: () => <Navigate to="/about" />,
    },
    {
        key: 'upload',
        path: '/upload',
        view: UploadView,
    },
    {
        key: 'linking',
        path: '/linking',
        view: LinkingView,
    },
    {
        key: 'export',
        path: '/export',
        view: ExportView,
    },
    {
        key: 'explore',
        path: '/explore',
        view: ExploreView,
    },
    {
        key: 'asset',
        path: '/asset',
        view: AssetTrackingView,
    },
    {
        key: 'edl',
        path: '/edl',
        view: EdlView,
    },
    {
        key: 'transkoder',
        path: '/transkoder',
        view: TranskoderView,
    },
    {
        key: 'illusion',
        path: '/illusion',
        view: IllusionView,
    },
    // {
    //     key: 'pipelinelab',
    //     path: '/pipelinelab',
    //     view: PipelineLab,
    // },
    {
        key: 'production',
        path: '/production',
        view: ProductionView,
    },
    {
        key: 'about',
        path: '/about',
        view: AboutView,
    },
    {
        key: 'settings',
        path: '/settings',
        view: SettingsView,
    },
    {
        key: 'sourceconfig',
        path: '/sourceconfig',
        view: SourceConfigView,
    },
    {
        key: 'fdl',
        path: '/fdl',
        view: FDLView,
    },
    {
        key: 'deliverableconfig',
        path: '/deliverableconfig',
        view: DeliverableConfigView,
    },
    {
        key: 'access',
        path: '/access',
        view: AccessManageView,
    },
    {
        key: 'account',
        path: '/account',
        view: AccountManageView,
    },
    {
        key: 'konsolconfig',
        path: '/konsolconfig',
        view: KonsolConfigView,
    },
    {
        key: 'lut',
        path: '/lut',
        view: LUTView,
    },
]


    
export default function KonsolRoutes(props){
    const { getLinkSummary, transferdate, getTransferDates, makeTour, isLoading, setIsLoading } = props

    return (
        <React.Fragment>
            <Routes>
                {routes.map((route) => (
                    <Route 
                        key={route.path}
                        path={route.path}
                        element={<route.view transferdate={transferdate} getTransferDates={getTransferDates} makeTour={makeTour} isLoading={isLoading} setIsLoading={setIsLoading} getLinkSummary={getLinkSummary} />}/>
                ))}
            </Routes>
        </React.Fragment>
    );
}